export default "__VITE_ASSET__Bbzzs4dm__"